import React, {useState} from 'react';

import {i18n} from '@netx/core/i18n';

import {useUpdateEffect} from '@netx/core-components/hooks';
import {isEmptyValue} from '@netx/core-components/Form';

import type {AttributeAttributes} from '@netx/core-asset/models/attribute';
import {ATTRIBUTE_MULTIPLE_VALUE_TYPES} from '../constants';

export interface Modifiers {
	cleared?: boolean;
	disable?: boolean;
	multipleValues?: boolean;
	readOnly?: boolean;
	value?: any;
}

export const usePlaceholder = (
	attrData: AttributeAttributes,
	defaultPlaceholder = '',
	modifiers: Modifiers = {
		cleared: false,
		disable: false,
		multipleValues: false,
		readOnly: false,
	},
): string => {
	const getPlaceholder = () => {
		const isMultipleField = ATTRIBUTE_MULTIPLE_VALUE_TYPES.includes(
			attrData.type,
		);
		return modifiers.disable || !isEmptyValue(modifiers.value)
			? ''
			: modifiers.cleared
			? i18n.t('i18n.tagPanelEmptiedValue')
			: (modifiers.multipleValues && i18n.t('i18n.tagPanelMultipleValues')) ||
			  (modifiers.readOnly && '(none)') ||
			  defaultPlaceholder ||
			  (isMultipleField ? i18n.t('i18n.makeSelection') : '');
	};

	const [placeholder, setPlaceholder] = useState(getPlaceholder());

	useUpdateEffect(() => {
		setPlaceholder(getPlaceholder());
	}, [attrData.type, defaultPlaceholder, modifiers]);

	return placeholder;
};

export default usePlaceholder;
